<template>
    <div>
        <div v-masonry transition-duration="0.3s" item-selector=".item" class="masonry-container" 
            v-viewer="{
                inline: false, 
                navbar: true,
                toolbar: false,
                title: false,
                
            }"
        >
            <div v-masonry-tile class="item" v-for="(file,index) in files" :key="index">
                <img v-if="!isVideo(file.file)" :src="file.file" />
                <div class="itemVideo r16x9" v-else>
                    <video :src="file.file" controls autoplay class="vid"></video>
                </div>
            </div>
        </div>
    </div>
</template>

<script async defer src="https://cdnjs.cloudflare.com/ajax/libs/masonry/4.0.0/masonry.pkgd.min.js"></script>
<script>
import Vue from 'vue'
import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin);

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer);
export default {
    props:['files'],
    methods:{
        getExtension(url){
            return url.split('.').pop();
        },
        isVideo(url){
            var ext = this.getExtension(url);
            if(ext=='mp4'){
                return true
            }else{
                return false
            }
        }
    }

}
</script>

<style scoped>

.masonry-container {
    width: 100%;
    margin: 0 auto;
    border-radius: 1rem;
    overflow: hidden;
}

  .grid-sizer,
  .item {
    width: 33.3333%;
  }
  @media (max-width: 892px){
    .grid-sizer,
    .item {
      width: 50%;
    }
  }

  @media (max-width: 450px){
    .grid-sizer,
    .item {
      width: 100%;
    }
  }

  .item {
    float: left;
  }

  .item img {
    display: block;
    width: 100%;
  }

   .item > img:hover {
    filter:grayscale(70%);
    cursor: pointer;
    transition: 300ms;
  }


    a{
      color: #222;
      text-decoration: none !important;
  }

  .cell-wrapper{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      cursor: pointer;
      background-color: rgba(250, 250, 250, 0.424);
      opacity: 0;
      color: rgb(15, 15, 15);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity .2s ease-out;
  }

  .cell-wrapper:hover{
      opacity: 1;
  }

   .loader{
    margin-top: 5vh;
    margin-bottom: 5vh;
    text-align: center;
  }
  .vid{
    width: 100%;
    height: auto;
  }
</style>